import { memo } from 'react';
import { Grid, Group, Select, Stack, Text, Title } from '@mantine/core';
import { Controller, useForm } from 'react-hook-form';

import { ConstructionSiteReviewFormValues } from './construction-site-review-form';

const stateOptions = ['Mal placé', 'Manquant', 'À finir'];
const cutOptions = ['AA', 'BB', 'CC', 'DD', 'EE', 'FF', 'GG'];

// Zod schema for validation (needed for type inference)

// Memoized category section component
export const CategorySection = memo(
  ({
    title,
    elements,
    control,
    errors,
  }: {
    title: string;
    elements: string[];
    control: ReturnType<
      typeof useForm<ConstructionSiteReviewFormValues>
    >['control'];
    errors: ReturnType<
      typeof useForm<ConstructionSiteReviewFormValues>
    >['formState']['errors'];
  }) => {
    if (elements.length === 0) return null;

    return (
      <Stack gap="xs" key={title}>
        <Title order={5} mb="xs">
          {title}
        </Title>
        <Grid gutter="xs" align="center">
          {elements.map(element => (
            <Grid.Col span={12} key={element}>
              <Group gap="xs" align="center" style={{ width: '100%' }}>
                <Text style={{ minWidth: 90, fontWeight: 500 }}>{element}</Text>
                <Controller
                  name={`table.${element}.state`}
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      data={stateOptions}
                      placeholder="Sélectionner l'état"
                      style={{ minWidth: 180, flex: 1 }}
                      error={errors.table?.[element]?.state?.message}
                    />
                  )}
                />
                <Controller
                  name={`table.${element}.cut`}
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      data={cutOptions}
                      placeholder="Sélectionner la coupe"
                      style={{ minWidth: 180, flex: 1 }}
                      error={errors.table?.[element]?.cut?.message}
                    />
                  )}
                />
              </Group>
            </Grid.Col>
          ))}
        </Grid>
      </Stack>
    );
  },
);

CategorySection.displayName = 'CategorySection';
